import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c(
        "thead",
        [
          _c(
            "tr",
            { class: `${_vm.sticky ? "sticky-header-row" : ""}` },
            [
              _vm._t(
                "before",
                function () {
                  return _vm._l(_vm.prefixColumns, function (pre) {
                    return _c(
                      "th",
                      {
                        key: pre,
                        class: `${_vm.sticky ? "sticky-header-row" : ""}`,
                        attrs: {
                          rowspan:
                            _vm.dateHeaders && _vm.dateHeaders.length > 0
                              ? _vm.dateHeaders.length
                              : 1,
                        },
                      },
                      [_vm._v(" " + _vm._s(pre) + " ")]
                    )
                  })
                },
                { dateHeaders: _vm.dateHeaders }
              ),
              !_vm.hideExpanableColumns &&
              _vm.openDates &&
              _vm.openDates.length > 0
                ? _c(
                    "th",
                    {
                      class: `${_vm.alignment} date-header`,
                      attrs: {
                        colspan:
                          _vm.dateHeaders.length == 1
                            ? _vm.leafColspan
                            : _vm.openDates.length * _vm.leafColspan,
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "header_text" },
                        [
                          _c(
                            VIcon,
                            {
                              staticClass: "mr-2",
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleDateNode(
                                    _vm.dateHeaders[0][0]
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dateHeaders[0][0].state == "closed"
                                    ? "mdi-plus-box-outline"
                                    : "mdi-minus-box-outline"
                                )
                              ),
                            ]
                          ),
                          _vm._v(
                            " " + _vm._s(_vm.dateHeaders[0][0].label) + " "
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._t(
                "after",
                function () {
                  return _vm._l(_vm.postfixColumns, function (post) {
                    return _c(
                      "th",
                      {
                        key: post,
                        class: `${_vm.sticky ? "sticky-header-row" : ""}`,
                        attrs: {
                          rowspan:
                            _vm.dateHeaders && _vm.dateHeaders.length > 0
                              ? _vm.dateHeaders.length
                              : 1,
                        },
                      },
                      [_vm._v(" " + _vm._s(post) + " ")]
                    )
                  })
                },
                { dateHeaders: _vm.dateHeaders }
              ),
            ],
            2
          ),
          !_vm.hideExpanableColumns
            ? _vm._l(_vm.dateHeaders.slice(1), function (row, rIndex) {
                return _c(
                  "tr",
                  {
                    key: rIndex,
                    class: `${
                      _vm.sticky ? "sticky-header-row-" + (rIndex + 2) : ""
                    }`,
                  },
                  _vm._l(row, function (col, cIndex) {
                    return _c(
                      "th",
                      {
                        key: rIndex + "-" + cIndex,
                        class: `${_vm.alignment} ${
                          col.children && col.children.length > 0
                            ? "date-header"
                            : ""
                        }`,
                        attrs: {
                          colspan:
                            col.isLeaf && col.state != "open"
                              ? _vm.leafColspan
                              : col.colspan * _vm.leafColspan,
                          rowspan: col.state == "open" ? 1 : col.maxDepth,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleDateNode(col)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "header_text" },
                          [
                            col.children && col.children.length > 0
                              ? _c(
                                  VIcon,
                                  { staticClass: "mr-2", attrs: { small: "" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        col.state == "closed"
                                          ? "mdi-plus-box-outline"
                                          : "mdi-minus-box-outline"
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" " + _vm._s(col.label) + " "),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                )
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }